import { getZrmListingInfo, getZrmUserInfo, type ZrmClickstreamListing } from '@zg-rentals/clickstream';
import { trackListingEvent } from '../../analytics';
import { trackUserEvent } from '../../analytics';
import { SEMANTIC_EVENT_NAME, TOPIC_TAG_TXT, TRIGGER_LOCATION, TRIGGER_OBJECT, TRIGGER_TYPE } from './globals';
import type { ZrmClickstreamUserOrNull } from '../../analytics/types';

// https://dataportal.zillowgroup.net/event-registry/6118
export const LEAD_MANAGEMENT_PAGE_VIEW_EVENT_TYPE_ID = '6118';
export const emitLeadManagementPageViewEvent = (user: ZrmClickstreamUserOrNull, listing: ZrmClickstreamListing) =>
  trackListingEvent({
    envelope: {
      event_type_id: LEAD_MANAGEMENT_PAGE_VIEW_EVENT_TYPE_ID,
      event_type_version_id: '4',
      event_template_id: '168',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: TRIGGER_TYPE.View,
      trigger_location_nm: TRIGGER_LOCATION.LeadManagementPage,
      trigger_source_nm: 'lead_management_page',
      trigger_object_nm: TRIGGER_OBJECT.NoTriggerObject,
    },
    semantic: {
      semantic_event_nm: SEMANTIC_EVENT_NAME.ViewContent,
      topic_tag_txt: [TOPIC_TAG_TXT.ZrmSatellite],
    },
    ...getZrmUserInfo(user),
    ...getZrmListingInfo(listing),
  });

// https://dataportal.zillowgroup.net/event-registry/6182
export const SLW_INBOX_PAGE_VIEW = '6182';
export const emitSlwInboxPageViewEvent = (user: ZrmClickstreamUserOrNull) =>
  trackUserEvent({
    envelope: {
      event_type_id: SLW_INBOX_PAGE_VIEW,
      event_type_version_id: '1',
      event_template_id: '167',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: TRIGGER_TYPE.View,
      trigger_location_nm: TRIGGER_LOCATION.IreneInbox,
      trigger_source_nm: 'irene_inbox',
      trigger_object_nm: TRIGGER_OBJECT.NoTriggerObject,
    },
    semantic: {
      semantic_event_nm: SEMANTIC_EVENT_NAME.ViewContent,
      topic_tag_txt: [TOPIC_TAG_TXT.ZrmSatellite],
    },
    ...getZrmUserInfo(user),
  });
